import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";

const TriplePictureTextSection = ({
  firstText,
  secondText,
  thirdText,
  firstImageSrc,
  secondImageSrc,
  thirdImageSrc,
}) => {
  return (
    <Row className={"justify-content-evenly mx-0"}>
      <Col xs={4} className={"d-none d-lg-block"}>
        <div className={"w-100 h-100"}>
          <Image src={firstImageSrc} width="70%" style={{ marginLeft: "30%" }} alt={"firstImage"} />
          <Row className={"mt-5"}>
            <Col className={"px-3"} style={{ paddingBottom: "15%" }}>
              <Image src={secondImageSrc} width="100%" alt={"secondImage"} />
            </Col>
            <Col className={"px-3"} style={{ paddingTop: "15%" }}>
              <Image src={thirdImageSrc} width="100%" alt={"thirdImage"} />
            </Col>
          </Row>
        </div>
      </Col>
      <Col xs={11} lg={7} xxl={5} className={"text-12 text-lg-18"} style={{ color: "#626C77" }}>
        <div className={"mb-4 d-lg-none  text-end"}>
          <Image src={firstImageSrc} width="85%" style={{ minWidth: 250 }} />
        </div>
        <Row className={"mb-4"}>{firstText}</Row>
        <div className={"mb-4 d-lg-none"}>
          <Image src={secondImageSrc} width="50%" style={{ minWidth: 200 }} />
        </div>
        <Row className={"mb-4"}>{secondText}</Row>

        <div className={"mb-4 d-lg-none  text-end"}>
          <Image src={thirdImageSrc} width="50%" style={{ minWidth: 200 }} />
        </div>
        <Row className={"mb-4"}>{thirdText}</Row>
      </Col>
    </Row>
  );
};
export default TriplePictureTextSection;
